import React from "react";

import CreativeViewPage from "../../misc/pages/CreativeViewPage";

const FinraComplaintsCreativePage = () => (
  <CreativeViewPage title="Finra Complaints" />
);

export default FinraComplaintsCreativePage;
